var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 22.5V28.5C31.5 29.2956 31.1839 30.0587 30.6213 30.6213C30.0587 31.1839 29.2956 31.5 28.5 31.5H7.5C6.70435 31.5 5.94129 31.1839 5.37868 30.6213C4.81607 30.0587 4.5 29.2956 4.5 28.5V22.5",
    stroke: "url(#paint0_linear_663_619)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12L18 4.5L10.5 12",
    stroke: "url(#paint1_linear_663_619)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5V22.5",
    stroke: "url(#paint2_linear_663_619)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_663_619",
    x1: 4.5,
    y1: 31.5,
    x2: 31.5,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_663_619",
    x1: 10.5,
    y1: 12,
    x2: 25.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_663_619",
    x1: 18,
    y1: 22.5,
    x2: 19,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGradient);
export default __webpack_public_path__ + "static/media/upload-gradient.31df850c8e81965e4957ef25236ad7cb.svg";
export { ForwardRef as ReactComponent };